export var FeeType;
(function (FeeType) {
    /** Fee is added to the ticket price at checkout. */
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    /** Seller absorbs the fee. It is deducted from the ticket price. */
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout. */
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var TicketSaleStatus;
(function (TicketSaleStatus) {
    /** Ticket sale is scheduled to start. */
    TicketSaleStatus["SALE_SCHEDULED"] = "SALE_SCHEDULED";
    /** Ticket sale has started. */
    TicketSaleStatus["SALE_STARTED"] = "SALE_STARTED";
    /** Ticket sale has ended. */
    TicketSaleStatus["SALE_ENDED"] = "SALE_ENDED";
})(TicketSaleStatus || (TicketSaleStatus = {}));
export var TicketDefinitionStateEnumState;
(function (TicketDefinitionStateEnumState) {
    TicketDefinitionStateEnumState["INCLUDE_HIDDEN_NOT_ON_SALE"] = "INCLUDE_HIDDEN_NOT_ON_SALE";
})(TicketDefinitionStateEnumState || (TicketDefinitionStateEnumState = {}));
export var Type;
(function (Type) {
    Type["STANDARD"] = "STANDARD";
    Type["DONATION"] = "DONATION";
})(Type || (Type = {}));
export var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    /** Include `policy` in the response. */
    TicketDefinitionFieldset["POLICY"] = "POLICY";
    /** Include `dashboard` in the response. */
    TicketDefinitionFieldset["DASHBOARD"] = "DASHBOARD";
})(TicketDefinitionFieldset || (TicketDefinitionFieldset = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var State;
(function (State) {
    /** The ticket is available for purchase. */
    State["VISIBLE"] = "VISIBLE";
    /** The ticket is unavailable for purchase. */
    State["HIDDEN"] = "HIDDEN";
    /** The ticket price is 0. */
    State["FREE"] = "FREE";
    /** The ticket price is greater than 0. */
    State["PAID"] = "PAID";
})(State || (State = {}));
export var GroupBy;
(function (GroupBy) {
    /** No grouping. */
    GroupBy["NONE"] = "NONE";
    /** Groups by event created date with descending sorting. */
    GroupBy["EVENT_CREATED_DESC"] = "EVENT_CREATED_DESC";
    /** Groups by event created date with ascending sorting. */
    GroupBy["EVENT_CREATED_ASC"] = "EVENT_CREATED_ASC";
})(GroupBy || (GroupBy = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map